<template>
  <div class="bg">
    <div class="logo_bg">
      <div class="min_head">
        <img class="head_img" :src="avatarUrl" alt="''" @click="onPrivacy('personCenter')" />
        <div class="head_name_wrap">
          <div class="username_icon">
            <p class="username" @click="onPrivacy('personCenter')">{{ personName }}</p>
            <p class="user_tips">{{ jobDesc }}</p>
          </div>
          <QrCodeScanner
            :pageType="2"
            @addDecode="handleAdd"
            v-if="!isTudoApp && !isSandsTalkFlutterApp && !isSandsTalkNativeApp && !isSandsTalkPhOutfieldApp && !isWisdomRabbitApp"
          />
        </div>
      </div>
      <div class="nav_wrapper">
        <div class="nav_item" v-for="(item, index) in navScreen" :key="item.to" @click="goJump(item.to)">
          <p class="item_num">{{ $t(item.num) }}</p>
          <p class="item_name">
            {{ $t(item.name) }}{{ index === 0 ? '(h)' : '' }}
            <Icon name="arrow" class="arrow" />
          </p>
        </div>
      </div>
    </div>
    <!--    我的   -->
    <div class="business_div">
      <p class="business_title">{{ $t('app_my') }}</p>
      <div class="business_wrapper">
        <div
          class="business_item"
          v-for="(item, index) in myScreen"
          :style="index < 4 ? { paddingBottom: '20px' } : { paddingBottom: '15px' }"
          :key="item.to"
          @click="goJump(item.to)"
        >
          <div class="item_img_box">
            <i :class="['iconfont', item.img]" />
            <span class="badge" v-if="item?.badgeNum > 0">
              {{ item?.badgeNum > 99 ? '99+' : item?.badgeNum }}
            </span>
          </div>
          <p class="item_img_name">{{ $t(item.name) }}</p>
        </div>
      </div>
    </div>
    <p class="business_space" />
    <!--    更多   -->
    <div class="business_div">
      <p class="business_title">{{ $t('app_more') }}</p>
      <div class="business_wrapper">
        <div class="business_item" v-for="item in moreScreen" :key="item.to" @click="goJump(item.to)">
          <div class="item_img_box">
            <i :class="['iconfont', item.img]" />
            <span class="badge" v-if="item?.badgeNum > 0">
              {{ item?.badgeNum > 99 ? '99+' : item?.badgeNum }}
            </span>
          </div>
          <p class="item_img_name">{{ $t(item.name) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ComponentInternalInstance, getCurrentInstance, reactive, toRefs, ref, onMounted, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { Icon } from 'vant'
import { getUserSimple } from '@/api/requests/RankRequests'
import { getValidateToken } from '@/api/requests/UserRequests'
import { getCornerMarkNumber } from '@/api/requests/TeachManageRequests'
import QrCodeScanner from '@/components/QRCodeScanner.vue'
import { isTudoApp } from '@/utils/tudo'
import { isWisdomRabbitApp } from '@/utils/sandsTalkSmartRabbit'
import { isOutFieldApp } from '@/utils/outfield'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkNativeApp } from '@/utils/sandsTalkNative'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'
import { toW, toHour } from '@/utils'
import { useAuthStore } from '@/stores/login'
import { getUserLabelInfo } from '@/api/requests/AppRequests'
const router = useRouter()
const { proxy } = getCurrentInstance() as ComponentInternalInstance

const userInfoData = reactive<{
  username?: string
  jobDesc?: string
  avatarUrl?: string
}>({
  username: '',
  jobDesc: '',
  avatarUrl: require('@/assets/images/wx_share_default.jpg')
})

let isFirstLoad = true
const { avatarUrl, jobDesc } = toRefs(userInfoData)
// const authStore = useAuthStore()
const moreScreen = ref()
const personName = ref()
const navScreen = ref([
  {
    name: 'study_time_h5',
    num: '24',
    to: '/studyTime'
  },
  {
    name: 'top_academic_h5',
    num: '9875',
    to: '/topAcademic'
  },
  {
    name: 'total_Integral_h5',
    num: '1.29',
    to: '/integral'
  }
])

// 注意数据顺序，不然影响显示徽标数据
const myScreen = ref([
  {
    name: 'app_my_studies',
    img: 'icon-icon_wode_xuexi',
    to: '/myStudy'
  },
  {
    name: 'app_my_training', // 培新项目
    img: 'icon-icon_wode_wodepeixun',
    to: '/myTraining',
    badgeNum: 0
  },
  {
    name: 'app_my_examination', // 考试与练习
    img: 'icon-icon_wode_kaoshi',
    to: '/examPractise',
    badgeNum: 0
  },
  {
    name: 'app_my_survey', // 调查
    img: 'icon-icon_wode_tiaoyan',
    to: '/mySurvey',
    badgeNum: 0
  },
  {
    name: 'app_offline_teaching',
    img: 'icon-xianxiamianshou',
    to: '/faceTeaching'
  },
  {
    name: 'certificate',
    img: 'icon-zhengshuguanli',
    to: '/myCertificate'
  },
  {
    name: 'pc_community_my_release',
    img: 'icon-icon_wode_wodefabu',
    to: '/myPublish'
  },
  {
    name: 'pc_common_my_love',
    img: 'icon-icon_wode_shoucang',
    to: '/myCollect'
  },
  {
    name: 'file_archive',
    img: 'icon-dangan',
    to: '/myArchive'
  }
])

const moreScreenData1 = [
  {
    name: 'app_feedback',
    img: 'icon-icon_wode_fankui',
    to: '/feedback'
  }
]
const moreScreenData = [
  {
    name: 'pc_my_team',
    img: 'icon-wode_tuanduixuexi',
    to: '/teamStudyList',
    show: false
  },
  {
    // 教学管理
    name: 'teaching_management', // app_
    img: 'icon-pic_jiaoxueguanli1',
    to: '/teachManage/TeachManageList',
    badgeNum: 0,
    show: false
  },
  {
    name: 'app_my_center',
    img: 'icon-gengduo_gerenzhongxin',
    to: '/personCenter',
    show: true
  },
  {
    name: 'app_feedback',
    img: 'icon-icon_wode_fankui',
    to: '/feedback',
    show: true
  },
  {
    name: 'settings',
    img: 'icon-icon_wode_shezhi',
    to: '/setting',
    show: true
  }
]

const handleMenu = async () => {
  if (isTudoApp || isOutFieldApp) {
    moreScreen.value = moreScreenData1
    return
  }
  // 保留：获取并修复 userId
  const res = await getValidateToken()
  if (res.code === 1) {
    const authStore = useAuthStore()
    const { setUserId } = authStore
    setUserId(res.data.id)
  }

  // 新增：通过 getUserLabelInfo 判断入口显示
  const labelRes = await getUserLabelInfo()
  if (labelRes.code === 1) {
    const { teachingMgtLabel = 0, teamLearningLabel = 0 } = labelRes.data || {}
    // 团队学习
    moreScreenData[0].show = teamLearningLabel === 1
    // 教学管理
    moreScreenData[1].show = teachingMgtLabel === 1
    moreScreen.value = moreScreenData.filter((item) => item.show)
  } else {
    // 接口失败兜底：不展示两个入口
    moreScreenData[0].show = false
    moreScreenData[1].show = false
    moreScreen.value = moreScreenData.filter((item) => item.show)
  }
}
const onPrivacy = (value: string) => {
  router.push(`/${value}`)
}

const goJump = (value: string) => {
  router.push(value)
}

const handleAdd = async (result: string) => {
  await router.push({ name: 'TrainingLink', query: { linkUrl: result } })
}

const getSimple = async () => {
  const res = await getUserSimple({})
  if (res.code === 1) {
    const { totalStudyDuringTime, monthRank, totalPoints } = res.data
    const { name, postName, avatarFileUrl } = res.data.user
    personName.value = name
    userInfoData.username = name
    userInfoData.jobDesc = postName
    userInfoData.avatarUrl = avatarFileUrl || require('@/assets/images/wx_share_default.jpg')
    navScreen.value[0].num = toW(toHour(totalStudyDuringTime, 'H')) || '0'
    navScreen.value[1].num = toW(monthRank) || '0'
    navScreen.value[2].num = toW(totalPoints) || '0'
    proxy?.$forceUpdate()
  }
}
// 获取徽标
const getBadge = async () => {
  const res = await getCornerMarkNumber()
  if (res.code === 1) {
    const { trainingNumber, examAndPracticeNumber, investigationNumber, teachingNumber, faceNumber } = res.data

    myScreen.value[1].badgeNum = trainingNumber
    myScreen.value[2].badgeNum = examAndPracticeNumber
    myScreen.value[3].badgeNum = investigationNumber
    myScreen.value[4].badgeNum = faceNumber
    moreScreenData[1].badgeNum = teachingNumber
  }
}

onActivated(() => {
  if (!isFirstLoad) {
    handleMenu()
    getSimple()
    getBadge()
  }
})

onMounted(() => {
  console.log('onMounted')
  if (isFirstLoad) {
    getSimple()
    handleMenu()
    getBadge()
    // 防止会重复请求
    setTimeout(() => {
      isFirstLoad = false
    }, 1500)
  }
})
</script>

<style lang="less" scoped>
@din_font: 'DIN Condensed, DIN Condensed-Bold, sans-serif', sans-serif;
@ping_fang_font: 'PingFang SC, PingFang SC-Regular, sans-serif';
@import url('@/styles/variables.less');
.iconfont {
  font-size: 28px;
}
.bg {
  background: linear-gradient(180deg, #f7f8f9, rgba(255, 255, 255, 0) 100%);
  .logo_bg {
    padding-top: 70px;
    background-image: url('~@/assets/images/my/sandy_logo.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-x: 100%;

    .min_head {
      display: flex;
      align-items: center;
      height: 50px;
      padding: 0 15px;
      .head_img {
        width: 45px;
        height: 45px;
        border-radius: 50%;
      }
      .head_name_wrap {
        flex: 1;
        height: 100%;
        padding-left: 13px;
        display: flex;
        justify-content: space-between;
        .username_icon {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
      .username {
        color: #171921;
        font-size: 18px;
        font-weight: 500;
      }
      .user_tips {
        margin-top: 6px;
        font-size: 12px;
        color: #999999;
        word-break: break-all;
        .arrow {
          color: #171921;
        }
      }
    }
  }
}
.business_div {
  background-color: #fff;
  margin: 0 12px;
  border-radius: 12px;
  .business_title {
    font-weight: 500;
    color: #171921;
    font-size: 14px;
    padding: 12px 0 16px 16px;
  }
}

.business_space {
  height: 10px;
}

.nav_wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 8px 12px 0 12px;
  .nav_item {
    width: calc(100% / 3);
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    align-items: center;
    .item_num {
      font-size: 23px;
      font-family: @din_font;
      font-weight: 700;
      color: #171921;
    }
    .item_name {
      font-size: 11px;
      // font-family: @ping_fang_font;
      font-weight: 400;
      text-align: center;
      color: #61666d;
      margin-bottom: 25px;
      .arrow {
        font-size: 10px;
      }
    }
  }
}

.business_wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0 5px;
  .business_item {
    width: calc(100% / 4);
    padding: 0 5px;
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .item_img_box {
    width: 28px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    position: relative;
    .badge {
      min-width: 16px;
      height: 16px;
      padding: 0 2px;
      font-size: 12px;
      background-color: #ef3838;
      border-radius: 16px;
      color: @textWhite;
      .flex_center;
      position: absolute;
      top: 0;
      right: -8px;
    }
  }
  .item_img_name {
    font-size: 12px;
    font-weight: 400;
    color: #171921;
    padding-top: 2px;
    text-align: center;
    // font-family: @ping_fang_font;
  }
  .item_num {
    font-size: 12px;
    font-weight: 400;
    color: #171921;
  }
}
</style>
